<template>
  <div
    class="source"
    :style="{
      '--source-color-dark': `var(--${color}-dark)`,
      '--source-color-main': `var(--${color}-main)`,
    }"
  >
    <div class="source__header">
      <div class="source__header--menu" @click="goToHomePage()">
        <svgicon
          name="menu"
          color="var(--primary-yellow)"
          height="2.625rem"
          width="2.625rem"
        />
      </div>
      <div class="source__header--filters"><Filters></Filters></div>
    </div>

    <div v-if="!isNoData" class="source__content">
      <div class="source__content__left">
        <TimeSerie></TimeSerie>

        <component
          v-if="sourceConfig"
          :is="sourceConfig.detailComponent"
        ></component>
      </div>

      <div class="source__content__center">
        <div class="source__content__center--dida">
          <SelectionLabel
            v-if="sourceConfig"
            :withUom="true"
            :fixedText="'Top Countries'"
            :withGeoArea="sourceConfig.geoAreas"
            type="map"
          ></SelectionLabel>
        </div>

        <div class="source__content__center__bottom">
          <div class="source__content__center__bottom--map">
            <!-- <transition name="fade" mode="out-in"> -->
            <!-- <Map :key="mapStyle" :mapStyle="mapStyle"></Map> -->
            <Map :mapStyle="mapStyle"></Map>
            <!-- </transition> -->
          </div>
        </div>
      </div>

      <div class="source__content__drillDown">
        <DrillDownButton
          v-if="$route.params.source === 'Oil'"
          :label="drillDownContent.label"
        />
        <Transition name="btt">
          <ModalDrillDown
            v-if="isDrillDownOpen && $route.params.source === 'Oil'"
            :content="drillDownContent.innerContent"
          />
        </Transition>
        <Transition name="fade">
          <Overlay v-if="isDrillDownOpen && $route.params.source === 'Oil'" />
        </Transition>
      </div>
    </div>

    <div
      v-else
      class="source__content noData"
      :style="{
        backgroundImage: `url(${$baseUrl}images/griglia.png)`,
      }"
    >
      NO DATA
    </div>

    <div class="source__footer" v-html="dataSourceByDataType"></div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Filters from "@/components/filters/Filters.vue";
import TimeSerie from "@/components/widgets/TimeSerie.vue";
import TotalShare from "@/components/widgets/TotalShare.vue";
import Top5 from "@/components/widgets/Top5.vue";
import Growth from "@/components/widgets/Growth.vue";
import Map from "@/components/widgets/Map.vue";
import SelectionLabel from "@/components/widgets/SelectionLabel.vue";
import Overlay from "@/components/drillDown/Overlay.vue";
import DrillDownButton from "@/components/drillDown/DrillDownButton.vue";
import ModalDrillDown from "@/components/drillDown/ModalDrillDown.vue";

export default {
  name: "SourcePageDesktop",
  components: {
    Filters,
    TimeSerie,
    TotalShare,
    Top5,
    Growth,
    Map,
    SelectionLabel,
    Overlay,
    DrillDownButton,
    ModalDrillDown,
  },
  data() {
    return {};
  },
  mounted() {
    // get key from url
    this.setMainSource(this.$route.params.source);
  },
  computed: {
    dataSourceByDataType() {
      let res = "";
      // check footer
      if (this.dataSource) {
        let r = this.dataSource.find((x) => x.dataType === this.dataType);
        // if (
        //   (this.geoArea === "World" &&
        //     this.dataType === "Production" &&
        //     this.mainSource !== "Critical Minerals") ||
        //   (this.geoArea === "World" &&
        //     this.dataType === "Consumption" &&
        //     this.mainSource !== "Critical Minerals") ||
        //   (this.geoArea === "Europe" &&
        //     this.dataType === "Consumption" &&
        //     this.mainSource !== "Critical Minerals")
        // ) {
        //   return "Data source: the original data are from IEA (2023) Extended Balances and, for Italy, from Italian Ministry for Ecological Transition. All rights reserved";
        // }
        if (r) {
          let prefix = this.$t("dashboard").sourceFooterPrefix;
          // this condition is needed to avoid error when dataType is still changing when switching from one source to another
          res = prefix + r.source;
        }
      }
      return res;
    },
    showGrowthComponent() {
      return this.setMainSource === "Critical Minerals";
    },
    drillDownContent() {
      return this.$t("drillDown");
    },
    color() {
      return this._color();
    },

    ...mapGetters({
      isDrillDownOpen: "ui/isDrillDownOpen",
      sourceConfig: "ui/currentSourceConfig",
      dataSource: "ui/dataSource",
      dataType: "ui/dataType",
      mapStyle: "ui/mapStyle",
      mainSource: "ui/mainSource",
      geoArea: "ui/geoArea",
      _color: "ui/sourceColor",
      currentSelectionLabel: "ui/currentSelectionLabel",
      isNoData: "data/isNoData",
    }),
  },
  methods: {
    goToHomePage() {
      this.toggleMenu(true);
      this.$router.push("/landing");
    },
    ...mapActions({
      setMainSource: "ui/setMainSource",
      toggleMenu: "ui/toggleMenu",
    }),
  },
};
</script>

<style lang="scss" scoped>
$widget-left-width: 24%;
$widget-right-width: 250;
.source {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  height: 100vh;
  width: 100%;

  &__header {
    height: toRem(#{$header-HEIGHT});
    width: 100vw;
    display: flex;
    flex-direction: row;

    &--menu {
      height: 100%;
      width: toRem(#{$header-HEIGHT});
      display: flex;
      justify-content: center;
      align-items: center;
      border-right: $white-border;
      transition: all 0.4s ease;
      background-color: var(--source-color-main);
      cursor: pointer;
      flex-shrink: 0;
    }

    &--filters {
      height: 100%;
      flex-grow: 1;
    }
  }

  &__content {
    height: calc(100% - toRem(#{$header-HEIGHT}));
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    transition: all 0.4s ease;
    background-color: var(--source-color-dark);
    position: relative;
    width: 100vw;

    &.noData {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      @include title-H3;
      color: $ui-white;
      background-position: center;
      background-size: cover;
    }

    &__left {
      // border: 1px solid red;
      height: 100%;
      width: $widget-left-width;
      display: flex;
      flex-direction: column;
      flex-shrink: 0;
      > div {
        flex-grow: 1;
      }
    }

    &__center {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      height: 100%;
      width: 100%;
      position: relative;

      &--dida {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
        height: toRem(40);
        padding: toRem(5) toRem(10);
        background-color: var(--source-color-dark);
        border-bottom: $white-border;
      }

      &__bottom {
        display: flex;
        flex-direction: row;
        justify-content: center;
        width: 100%;
        height: 100%;

        &--map {
          flex-grow: 1;
        }

        &--top5 {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: center;
          height: 100%;
          width: toRem(#{$widget-right-width});
        }
      }
    }

    &__drillDown {
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translate(-50%, 0);
      z-index: 20;
    }
  }

  &__footer {
    padding: toRem(4) toRem(10);
    height: toRem(25);
    width: fit-content;
    background-color: rgba(255, 255, 255, 0.05);
    position: absolute;
    left: 0;
    bottom: 0;
    color: $gray_03;

    font-family: "Open Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    line-height: 17px;
    /* identical to box height, or 170% */

    letter-spacing: 0.025em;
  }
}
</style>
